// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1lpFF","title":"card_title__2Isai","inActive":"card_inActive__2qreS"};